<template>
  <el-container>
    <el-aside width="180px" v-if="isNavbarVisible">
      <navbar />
    </el-aside>
    <el-container>
      <el-header>
        <Header />
      </el-header>
      <el-main> <app-main /></el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Navbar, AppMain, Header } from "./components/index";

export default {
  name: "Layout",
  components: {
    Navbar,
    AppMain,
    Header,
  },
  data() {
    return {
      isNavbarVisible: true,
    };
  },
  created() {
    this.isNavbarVisible = this.getInitialNavbarVisibility();
    this.updateNavbarVisibilityBasedOnRoute(this.$route);
  },
  methods: {
    toggleNavbar() {
      this.isNavbarVisible = !this.isNavbarVisible;
      this.saveNavbarVisibility();
    },
    saveNavbarVisibility() {
      localStorage.setItem("isNavbarVisible", this.isNavbarVisible);
    },
    getInitialNavbarVisibility() {
      const storedVisibility = localStorage.getItem("isNavbarVisible");
      return storedVisibility === null || storedVisibility === "true";
    },
    updateNavbarVisibilityBasedOnRoute(to) {
      if (to.meta && to.meta.hideNavbar !== undefined) {
        this.isNavbarVisible = !to.meta.hideNavbar;
        this.saveNavbarVisibility();
      } else {
        this.isNavbarVisible = true;
        this.saveNavbarVisibility();
      }
    },
  },
  watch: {
    $route(to) {
      this.updateNavbarVisibilityBasedOnRoute(to);
    },
  },
};
</script>

<style lang="scss">
.el-aside {
  height: 100vh;
  background-color: #8c52da;
}

.el-header {
  padding: 0 !important;
}

.el-main {
  padding: 0 10px !important;
  height: calc(100vh - 60px) !important;
  overflow-y: auto !important;
}
</style>
